import React from 'react';

import { MessageType } from '@savgroup-front-common/types';

import { createGenericContext } from '../../helpers';

export interface ConfirmationContextArgs {
  isOpen: boolean;
  resolver?: {
    resolve?: (value: boolean) => void;
  };
  title?: MessageType;
  didactic?: MessageType;
  getConfirmation: ({
    title,
    didactic,
    children,
  }: {
    title: MessageType;
    didactic: MessageType;
    children?: React.ReactNode;
  }) => Promise<boolean>;
  refConfirmationModal: React.RefObject<HTMLDivElement | null>;
}

export const [useConfirmationContext, ConfirmationContext] =
  createGenericContext<ConfirmationContextArgs>();
